import type { ComponentPropsWithoutRef } from 'react';

import { VisxText } from '@/components/VisxText';

type VisxTextProps = Pick<
  ComponentPropsWithoutRef<typeof VisxText>,
  'onClick' | 'className' | 'children'
>;

type Props = {
  x: number;
  y: number;
  width: number;
};

export const Label = ({
  children,
  className,
  ...rest
}: Props & VisxTextProps) => {
  return (
    <VisxText
      {...rest}
      dx={4}
      dy={-12}
      typography="xSmall"
      lineHeight="1.4em"
      verticalAnchor="end"
      className={className}
    >
      {children}
    </VisxText>
  );
};
